import {
  Button,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Theme,
} from "@material-ui/core";
import { API, graphqlOperation } from "aws-amplify";
import MaterialTable from "material-table";
import React, { Fragment, useEffect, useState } from "react";
import MuiForm from "rjsf-material-ui";
import { DataPortalService, Role } from "../../api/DataPortalService";
import { v4 as uuidv4 } from "uuid";
import * as mutation from "../../api/graphql/mutations";
import * as query from "../../api/graphql/queries";
import AtlasPanel from "../../atlas/blades/AtlasPanel";
import { KeyValue } from "../../api/models";

const ProjectTags: React.FC<any> = ({ theme, project, role }) => {
  if (project === null) {
    return <Fragment />;
  }

  const [data, setData] = useState<Array<any>>([]);

  useEffect(() => {
    project.tags = project.tags || [];
    setData(project.tags.map((v) => Object.assign({}, v)));
  }, [project]);

  return (
    <MaterialTable
      title="Tags"
      columns={[
        { title: "Name", field: "key" },
        { title: "Value", field: "value" },
      ]}
      data={data}
      options={{
        showTitle: true,
        grouping: false,
        exportButton: false,
        columnsButton: false,
        search: false,
        pageSize: 5,
        pageSizeOptions: [],
        actionsColumnIndex: -1,
        headerStyle: {
          fontSize: "12px",
          fontWeight: "bold",
          padding: "3px 10px",
          whiteSpace: "nowrap",
          textTransform: "capitalize",
          zIndex: 0,
        },
        rowStyle: {
          fontSize: "13px",
        },
      }}
      editable={
        role === Role.ADMIN
          ? {
              onRowAdd: (tag) => {
                return DataPortalService.setProjectTags(project, [
                  ...(project.tags || []),
                  tag,
                ]);
              },
              onRowUpdate: (newData, oldData) => {
                const index = oldData.tableData.id;
                project.tags[index] = {
                  key: newData.key,
                  value: newData.value,
                };
                return DataPortalService.setProjectTags(project, project.tags);
              },
              onRowDelete: (oldData) => {
                const index = oldData.tableData.id;
                project.tags.splice(index, 1);
                return DataPortalService.setProjectTags(project, project.tags);
              },
            }
          : {}
      }
    />
  );
};

export default ProjectTags;
